export default __webpack_public_path__ + "media/images/dummy-d6ab738dc4b1002760cf463090674566.png";